import React from 'react'
import PropTypes from 'prop-types'
import Container from '@mui/material/Container'
import LoadingMessage from './LoadingMessage'
import MainHero from './MainHero'
import MatchingHeroes from '../MatchList'
import MatchSearch from '../MatchSearch'
import './MatchMakerPage.css'

const MatchMakerPage = props => {
    const {
        cardView,
        filters,
        hasLoaded,
        heroCount,
        heroes,
        highlights,
        isLoading,
        isWallet,
        loadingMessage,
        mainHero,
        onFilterChange,
        onMatchSelected,
        onSelectedHeroChange,
        onSearch,
        onSortByChange,
        onViewToggled,
        summoningEnabled,
    } = props

    return (
        <Container maxWidth="xl">
            <MatchSearch
                filters={filters}
                isLoading={isLoading}
                isWallet={isWallet}
                onFilterChange={onFilterChange}
                onSelectedHeroChange={onSelectedHeroChange}
                onSearch={onSearch}
                onSortByChange={onSortByChange}
                onViewToggled={onViewToggled}
            />

            <LoadingMessage
                heroCount={heroCount}
                isLoading={isLoading}
                hasLoaded={hasLoaded}
                message={loadingMessage}
            />

            <div className="hero-list">
                <MainHero hero={mainHero} view={cardView} />
                <MatchingHeroes heroes={heroes} highlights={highlights} onMatchSelected={onMatchSelected} selectable={summoningEnabled} view={cardView} />
            </div>
        </Container>
    )
}

MatchMakerPage.propTypes = {
    filters: PropTypes.object,
    hasLoaded: PropTypes.bool,
    mainHero: PropTypes.object,
    heroCount: PropTypes.number,
    heroes: PropTypes.array,
    highlights: PropTypes.object,
    isLoading: PropTypes.bool,
    isWallet: PropTypes.bool,
    loadingMessage: PropTypes.string,
    onFilterChange: PropTypes.func,
    onMatchSelected: PropTypes.func,
    onSelectedHeroChange: PropTypes.func,
    onSearch: PropTypes.func,
    onSortByChange: PropTypes.func,
    onViewToggled: PropTypes.func,
    view: PropTypes.string,
}

export default MatchMakerPage
